module.exports = __webpack_public_path__ + "img/img_load_fail.38b85f3b.svg";